import React, { FC } from "react";
import { List } from "stentor-models";
import { Card } from "../Card";
import "./Cards.scss";

export interface CardsProps {
    readonly list: List;
}

export const Cards: FC<CardsProps> = props => {
    const { list } = props;

    return (
        <div className="xapp-search-cards">
            {list.items.map((item, index) => (
                <Card key={index} item={item} />
            ))}
        </div>
    );
};
